import { render, staticRenderFns } from "./collections_modal.vue?vue&type=template&id=46e83e58&scoped=true&"
import script from "./collections_modal.vue?vue&type=script&lang=js&"
export * from "./collections_modal.vue?vue&type=script&lang=js&"
import style0 from "./collections_modal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./collections_modal.vue?vue&type=style&index=1&id=46e83e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e83e58",
  null
  
)

export default component.exports